import React from 'react';
import gql from 'graphql-tag';
import {FormattedMessage} from 'react-intl';
import IconButton from '../IconButton/IconButton';

export const fragments = {
    searchBanner: gql`
        fragment UrgentMessageSearchBanner on SearchBanner {
            countOfVisitors
            location
        }
    `
};

export function Icon() {
    return <IconButton icon="alarm-clock" />;
}

export function Content({countOfVisitors, location}) {
    return (
        <div className="UrgentMessageSearchBannerContent">
            <span className="SearchBanner__callToAction">
                <FormattedMessage
                    id="percentBookedPopularTitle"
                    defaultMessage="Book soon!"
                />
            </span>
            <span className="SearchBanner__explanation">
                <FormattedMessage
                    id="countOfVisitorsLookingAtLocation"
                    description=""
                    values={{
                        countOfVisitors,
                        location
                    }}
                />
            </span>
        </div>
    );
}

export default {
    fragments,
    Icon,
    Content
};
